module.exports = __webpack_public_path__ + "static/img/img2.cd84106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img2.png
// module id = LQux
// module chunks = 1